import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'react-bootstrap';
import Radium from 'radium';

import styles from './styles';

@Radium
export default class Team extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    facebook_url: PropTypes.string,
    url: PropTypes.string,
    logo_url: PropTypes.string.isRequired,
  }

  static defaultProps = {
    facebook_url: undefined,
    url: undefined
  };

  render() {
    const { name, facebook_url: facebookUrl, url, logo_url: logoUrl } = this.props;

    return (
      <div style={styles.card}>
        <h3 style={styles.h3}>{name}</h3>
        <img src={logoUrl} alt={name} style={styles.img} />
        <ButtonToolbar style={styles.toolbar}>
          { facebookUrl &&
          <Button bsStyle="facebook" bsSize="xs" href={facebookUrl} target="_blank">
            <i className="fa fa-facebook-official">&nbsp;</i>
            Facebook
          </Button>
          }
          { url &&
          <Button bsStyle="success" bsSize="xs" href={url} target="_blank">
            <i className="fa fa-globe">&nbsp;</i>
            Web
          </Button>
          }
        </ButtonToolbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_section/team.jsx